import { InputMask } from './types'

// Mirrors TextInput's historical `format='currency'` behavior byte-for-byte:
// input is rejected (not stripped) when it fails the amount pattern, and blur
// pads to exactly two decimals.
const amountPattern = /^\d*([.]?\d{0,2})?$/

export const currencyFormat: InputMask = {
  sanitize: (input) => (amountPattern.test(input) ? input : null),
  format: (raw) => raw,
  normalizeOnBlur: (raw) => Number(raw).toFixed(2),
  placeholder: '0.00',
  prefix: '$',
}
